export default __webpack_public_path__ + "static/media/zyda-logo-black.f788cc43.svg";